<mat-dialog-content>
    <video width="100%" controls autoplay>
        <source [src]="apiUrl + '/user/help/tutorial.mov'" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
</mat-dialog-content>
